export const SET_HEADER_VISIBLE = "SET_HEADER_VISIBLE";

const headerVisible = (state = true, action) => {
  switch (action.type) {
    case SET_HEADER_VISIBLE:
      return action.payload;

    default:
      return state;
  }
};

export default headerVisible;
